const prefix = 'sky';
export enum SessionStorageType {
  TOKEN = `${prefix}.token`,
}
